import React from 'react'
import { Text } from 'marketing-site/src/library/elements/Text'
import { CTATheme } from 'marketing-site/src/library/utils'
import { CTALink } from 'marketing-site/src/library/elements/CTALink'
import { EditorialStoryGrid } from 'marketing-site/src/library/components/EditorialStoryGrid'
import { IEditorialStories } from './index'

import styles from './styles.scss'

export const EditorialStories = ({
  headline,
  slug,
  customerStoryGrid,
}: IEditorialStories): React.ReactElement | null => {
  if (!customerStoryGrid) return null

  return (
    <>
      <div className="editorial-stories">
        {(headline || slug) && (
          <div className="editorial-stories__header">
            {headline && (
              <h2 className="editorial-stories__heading">
                <Text brand="default" size="heading-2">
                  {headline}
                </Text>
              </h2>
            )}
            {slug && (
              <div className="editorial-stories__view-all-link">
                <CTALink url={slug} bgColor={CTATheme.LinkOnlyBlack} text="View all" arrow={true} />
              </div>
            )}
          </div>
        )}
        <div className="editorial-stories__body">
          <EditorialStoryGrid {...customerStoryGrid} asFullGrid />
        </div>

        <style jsx>{styles}</style>
      </div>
    </>
  )
}
